// extracted by mini-css-extract-plugin
export default {"container":"Liquidation_container__cF36J"};